module.exports = __webpack_public_path__ + "img/major4.be3f4c91.png";